import React from 'react';

export const NotFoundSvg = ({ ...rest }) => {
  return (
    <svg
      width="858"
      height="688"
      viewBox="0 0 858 688"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <ellipse cx="485.5" cy="356" rx="323.5" ry="332" fill="url(#paint0_linear_713_4489)" />
      <circle cx="248" cy="82" r="76" fill="#79A4E2" stroke="white" strokeWidth="12" />
      <path d="M244.147 33.8348H248.642V87.7798H244.147V33.8348Z" fill="#C8DEFF" />
      <path d="M244.147 90.3486V85.8532H281.395V90.3486H244.147Z" fill="#C8DEFF" />
      <path
        d="M24.5163 422.203C9.94407 395.057 2.97145 363.429 25.1809 343.3C46.8014 323.704 76.8346 322.406 98 343.299C118.375 363.412 112.981 379.526 134.5 396C156.468 412.817 175.289 399.071 191 422.203C205.416 443.429 194.448 472.828 214.484 488.428C226.686 497.928 231.822 493.964 244.914 502.076C273.371 519.709 290.381 594.459 268.5 619.5C246.192 645.029 179.225 631.5 161 606.445C142.775 581.389 158.999 552.286 146.5 536C129.214 513.476 117.67 535.331 98 515C79.2295 495.599 89.4775 477.305 75.5 454C62.4515 432.244 36.5271 444.578 24.5163 422.203Z"
        fill="#A5C9FF"
      />
      <path
        d="M24.5163 422.203C9.94407 395.057 2.97145 363.429 25.1809 343.3C46.8014 323.704 76.8346 322.406 98 343.299C118.375 363.412 112.981 379.526 134.5 396C156.468 412.817 175.289 399.071 191 422.203C205.416 443.429 194.448 472.828 214.484 488.428C226.686 497.928 231.822 493.964 244.914 502.076C273.371 519.709 290.381 594.459 268.5 619.5C246.192 645.029 179.225 631.5 161 606.445C142.775 581.389 158.999 552.286 146.5 536C129.214 513.476 117.67 535.331 98 515C79.2295 495.599 89.4775 477.305 75.5 454C62.4515 432.244 36.5271 444.578 24.5163 422.203Z"
        fill="#A5C9FF"
      />
      <path
        d="M24.5163 422.203C9.94407 395.057 2.97145 363.429 25.1809 343.3C46.8014 323.704 76.8346 322.406 98 343.299C118.375 363.412 112.981 379.526 134.5 396C156.468 412.817 175.289 399.071 191 422.203C205.416 443.429 194.448 472.828 214.484 488.428C226.686 497.928 231.822 493.964 244.914 502.076C273.371 519.709 290.381 594.459 268.5 619.5C246.192 645.029 179.225 631.5 161 606.445C142.775 581.389 158.999 552.286 146.5 536C129.214 513.476 117.67 535.331 98 515C79.2295 495.599 89.4775 477.305 75.5 454C62.4515 432.244 36.5271 444.578 24.5163 422.203Z"
        fill="#A5C9FF"
      />
      <path
        d="M338.421 268.66C354.188 242.19 377.711 219.927 406.403 228.601C434.334 237.045 443.938 267.144 436.926 296.046C430.175 323.869 412.093 332.481 409.052 359.411C405.946 386.902 436.216 402.272 424.476 427.651C413.704 450.939 382.523 440.4 379.467 465.609C377.606 480.96 383.648 483.322 383.435 498.721C382.972 532.195 339.732 580.025 307 574.161C273.628 568.183 250.525 506.77 264.03 474.917C272.05 456.003 293.949 457.061 301.475 437.961C311.882 411.545 269.513 404.405 276.813 377.074C283.78 350.993 313.546 352.188 326.326 328.206C338.258 305.818 325.425 290.477 338.421 268.66Z"
        fill="#A5C9FF"
      />
      <path
        d="M338.421 268.66C354.188 242.19 377.711 219.927 406.403 228.601C434.334 237.045 443.938 267.144 436.926 296.046C430.175 323.869 412.093 332.481 409.052 359.411C405.946 386.902 436.216 402.272 424.476 427.651C413.704 450.939 382.523 440.4 379.467 465.609C377.606 480.96 383.648 483.322 383.435 498.721C382.972 532.195 339.732 580.025 307 574.161C273.628 568.183 250.525 506.77 264.03 474.917C272.05 456.003 293.949 457.061 301.475 437.961C311.882 411.545 269.513 404.405 276.813 377.074C283.78 350.993 313.546 352.188 326.326 328.206C338.258 305.818 325.425 290.477 338.421 268.66Z"
        fill="#A5C9FF"
      />
      <path
        d="M338.421 268.66C354.188 242.19 377.711 219.927 406.403 228.601C434.334 237.045 443.938 267.144 436.926 296.046C430.175 323.869 412.093 332.481 409.052 359.411C405.946 386.902 436.216 402.272 424.476 427.651C413.704 450.939 382.523 440.4 379.467 465.609C377.606 480.96 383.648 483.322 383.435 498.721C382.972 532.195 339.732 580.025 307 574.161C273.628 568.183 250.525 506.77 264.03 474.917C272.05 456.003 293.949 457.061 301.475 437.961C311.882 411.545 269.513 404.405 276.813 377.074C283.78 350.993 313.546 352.188 326.326 328.206C338.258 305.818 325.425 290.477 338.421 268.66Z"
        fill="#A5C9FF"
      />
      <path
        d="M391.5 269C391.5 269 353.334 336.856 341 385.5C329.386 431.304 322.5 524 322.5 524"
        stroke="#FFF8F8"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path
        d="M99.1571 295.277C89.8781 260.99 90.6891 223.753 122.157 207.277C152.791 191.237 186.459 207.69 205.157 236.777C223.157 264.777 215.302 286.533 235.657 310.777C256.436 335.526 294.924 323.167 306.657 353.277C317.423 380.905 282.278 397.912 301.157 420.777C312.654 434.701 319.736 431.663 332.657 444.277C360.744 471.696 365.127 545.723 332.657 567.777C299.554 590.261 227.914 559.561 212.157 522.777C202.8 500.934 222.087 483.865 212.157 462.277C198.424 432.419 156.777 461.33 139.657 433.277C123.32 406.507 149.327 383.11 139.657 353.277C130.63 325.427 106.805 323.537 99.1571 295.277Z"
        fill="#C4DBFF"
      />
      <path
        d="M147.5 258.5C147.5 258.5 203.459 319.913 232 364.5C259.73 407.819 291.5 482 291.5 482M53.5 381C53.5 381 117.366 426.404 147.5 465.5C177.409 504.304 205 577 205 577"
        stroke="#FFF8F8"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path
        d="M283 342C284.954 333.008 290 319.5 290 319.5C290 319.5 256.943 314.228 236.5 308C219.294 302.758 193.5 291.5 193.5 291.5C193.5 291.5 185.5 305.321 181 314.5C159.255 358.852 156.258 387.605 156.5 437C156.795 497.265 181 554.906 205 583.5C243.422 629.276 278.5 657.543 332.5 656.5C410 655.003 463.5 575 463.5 575C463.5 575 505.194 670.146 604.119 670C674.539 669.896 721.596 623.482 746.619 559.5C765 512.5 785 379 744.5 296C718.296 242.298 689.46 200.431 630 194.5C549 186.42 506 238 488 278C470 318 443 372.5 443 372.5C443 372.5 385.736 493.2 329 474.5C276.979 457.354 271.37 395.525 283 342Z"
        fill="#65A1FA"
      />
      <path
        d="M283 342C284.954 333.008 290 319.5 290 319.5C290 319.5 256.943 314.228 236.5 308C219.294 302.758 193.5 291.5 193.5 291.5C193.5 291.5 185.5 305.321 181 314.5C181 314.5 208.504 325.595 226.75 330.75C248.308 336.841 283 342 283 342Z"
        fill="#2D61AE"
      />
      <path
        d="M631.5 223C611 221.029 608 197 608 197C608 197 624.232 195.493 634.5 197C645.083 198.553 660 205 660 205C660 205 655 225.26 631.5 223Z"
        fill="#4E89E3"
      />
      <path
        d="M317.5 611.5C294.928 611.694 272 638.5 272 638.5C272 638.5 298.456 651.415 317.5 653C336.544 654.585 363.5 647.5 363.5 647.5C363.5 647.5 343.072 611.28 317.5 611.5Z"
        fill="#4E89E3"
      />
      <path
        d="M669 608.5C657.884 624.79 662 653.5 662 653.5C662 653.5 683.582 642.483 694.5 633C709.883 619.639 724.5 596 724.5 596C724.5 596 683.276 587.579 669 608.5Z"
        fill="#4E89E3"
      />
      <path
        d="M419 516.5C412.801 477.318 414 427 414 427C414 427 432.335 401.964 442 384C451.665 366.036 463.5 335 463.5 335L510 479.5C510 479.5 473.871 485.523 460.5 510.5L456.242 575.318C456.362 577.319 456.321 578.614 456 579C451.607 584.272 437.5 599.5 437.5 599.5C437.5 599.5 424.107 548.777 419 516.5Z"
        fill="#4E89E3"
      />
      <path
        d="M641 382C630.5 402 634 438 634 438L584 469.5C584 469.5 573.524 449.183 572 435C568.773 404.967 572.129 381.749 592 359C606.081 342.879 634 327.5 647 335C660 342.5 651.5 362 641 382Z"
        fill="#4E89E3"
      />
      <path
        d="M456 579C451.607 584.272 437.5 599.5 437.5 599.5C437.5 599.5 424.107 548.777 419 516.5C412.801 477.318 414 427 414 427C414 427 432.335 401.964 442 384C451.665 366.036 463.5 335 463.5 335L510 479.5C510 479.5 473.871 485.523 460.5 510.5M456 579C458.129 576.445 447.924 533.992 460.5 510.5M456 579L460.5 510.5M608 197C608 197 611 221.029 631.5 223C655 225.26 660 205 660 205C660 205 645.083 198.553 634.5 197C624.232 195.493 608 197 608 197ZM272 638.5C272 638.5 294.928 611.694 317.5 611.5C343.072 611.28 363.5 647.5 363.5 647.5C363.5 647.5 336.544 654.585 317.5 653C298.456 651.415 272 638.5 272 638.5ZM662 653.5C662 653.5 657.884 624.79 669 608.5C683.276 587.579 724.5 596 724.5 596C724.5 596 709.883 619.639 694.5 633C683.582 642.483 662 653.5 662 653.5ZM634 438C634 438 630.5 402 641 382C651.5 362 660 342.5 647 335C634 327.5 606.081 342.879 592 359C572.129 381.749 568.773 404.967 572 435C573.524 449.183 584 469.5 584 469.5L634 438Z"
        stroke="#4E89E3"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path
        d="M472.5 483.5C472.5 483.5 472.5 496.3 463.5 509.5C463.5 509.5 513.506 518.951 555.5 509.5C592.987 501.063 643 464.5 643 464.5L635 437C635 437 585.669 477.225 547.5 486C507.626 495.167 472.5 483.5 472.5 483.5Z"
        fill="#2D61AE"
      />
      <path
        d="M463.5 575C463.5 575 450.5 540 463.5 509.5M463.5 509.5C472.5 496.3 472.5 483.5 472.5 483.5C472.5 483.5 507.626 495.167 547.5 486C585.669 477.225 635 437 635 437L643 464.5M463.5 509.5C463.5 509.5 513.506 518.951 555.5 509.5C592.987 501.063 643 464.5 643 464.5M643 464.5C643 464.5 646.29 522.105 673 527.5C706.383 534.243 692.5 442.5 692.5 442.5"
        stroke="#2D61AE"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M199.5 370.5C199.5 370.5 207.493 379.822 214.5 382.5C222.708 385.637 230.244 376.882 237 382.5C242.413 387.001 243 399.5 243 399.5M195.311 523.877C195.311 523.877 202.678 514.053 203.773 506.632C205.056 497.939 194.875 492.481 198.894 484.667C202.115 478.406 214.189 475.123 214.189 475.123M288.702 595.317C288.702 595.317 288.331 583.043 284.557 576.56C280.136 568.966 268.774 571.051 267.041 562.437C265.652 555.535 273.041 545.437 273.041 545.437M359.032 493.227C359.032 493.227 360.993 505.349 365.576 511.287C370.945 518.243 381.94 514.701 384.777 523.018C387.049 529.681 381.034 540.653 381.034 540.653M525.572 569.338C525.572 569.338 531.045 580.33 537.185 584.639C544.378 589.687 553.825 583.039 559.003 590.137C563.153 595.825 560.668 608.088 560.668 608.088M586 544.707C586 544.707 597.541 540.514 602.518 534.901C608.347 528.326 602.811 518.187 610.45 513.845C616.57 510.366 628.473 514.224 628.473 514.224M568.619 252.933C568.619 252.933 560.48 262.128 558.788 269.437C556.806 277.997 566.511 284.262 561.872 291.724C558.155 297.703 545.855 299.998 545.855 299.998M652 260.091C652 260.091 660.834 268.62 668.062 270.627C676.529 272.978 683.208 263.553 690.462 268.511C696.275 272.483 698.035 284.872 698.035 284.872M722.359 355C722.359 355 722.644 367.276 726.374 373.785C730.741 381.409 742.117 379.403 743.791 388.029C745.132 394.941 737.673 404.987 737.673 404.987M607.248 657.124C607.248 657.124 615.745 648.259 617.726 641.024C620.046 632.549 610.597 625.904 615.529 618.632C619.48 612.805 631.861 611 631.861 611M701.424 529C701.424 529 706.165 537.863 711.54 541.629C717.835 546.039 726.192 541.609 730.701 547.452C734.313 552.134 732.044 561.396 732.044 561.396"
        stroke="#91BCFF"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path
        d="M788.447 188.757H794.515V532.135H788.447V188.757Z"
        fill="url(#paint1_linear_713_4489)"
      />
      <path
        d="M727.508 519.745H855.453L834.213 653H751.53L727.508 519.745Z"
        fill="url(#paint2_linear_713_4489)"
      />
      <path
        d="M834.466 281.555C834.466 304.876 815.674 323.782 792.492 323.782C769.311 323.782 750.518 304.876 750.518 281.555C750.518 258.234 769.311 239.328 792.492 239.328C815.674 239.328 834.466 258.234 834.466 281.555Z"
        fill="url(#paint3_linear_713_4489)"
      />
      <path
        d="M817.778 191.538C817.778 205.643 806.457 217.077 792.492 217.077C778.527 217.077 767.207 205.643 767.207 191.538C767.207 177.434 778.527 166 792.492 166C806.457 166 817.778 177.434 817.778 191.538Z"
        fill="url(#paint4_linear_713_4489)"
      />
      <path
        d="M857.729 405.96C857.729 442.129 828.521 471.45 792.492 471.45C756.463 471.45 727.255 442.129 727.255 405.96C727.255 369.791 756.463 340.47 792.492 340.47C828.521 340.47 857.729 369.791 857.729 405.96Z"
        fill="url(#paint5_linear_713_4489)"
      />
      <path
        d="M344.5 128.346C343.2 115.902 353.517 105.333 365.988 106.331L495.33 116.687C504.934 117.456 512.625 124.963 513.626 134.545L542.232 408.368C543.532 420.812 533.216 431.381 520.744 430.383L391.402 420.027C381.799 419.258 374.108 411.751 373.107 402.169L344.5 128.346Z"
        fill="#2C2626"
      />
      <path
        d="M363.57 137.855C363.065 131.71 368.188 126.576 374.335 127.068L413.933 130.237C418.818 130.628 422.7 134.502 423.101 139.386L426.356 178.988C426.862 185.133 421.739 190.267 415.592 189.775L375.994 186.606C371.109 186.215 367.227 182.341 366.826 177.457L363.57 137.855Z"
        fill="#171515"
      />
      <path
        d="M391.679 146.503C391.662 153.305 387.031 158.81 381.337 158.798C375.642 158.786 371.04 153.262 371.058 146.459C371.076 139.657 375.706 134.152 381.4 134.164C387.095 134.176 391.697 139.7 391.679 146.503Z"
        fill="#040404"
      />
      <path
        d="M415.859 148.287C415.842 155.09 411.211 160.594 405.517 160.582C399.822 160.57 395.22 155.046 395.238 148.244C395.256 141.442 399.886 135.937 405.58 135.949C411.275 135.961 415.877 141.485 415.859 148.287Z"
        fill="#040404"
      />
      <path
        d="M392.252 172.932C392.235 179.734 387.604 185.239 381.91 185.227C376.215 185.215 371.613 179.691 371.631 172.888C371.649 166.086 376.279 160.581 381.973 160.593C387.668 160.605 392.27 166.13 392.252 172.932Z"
        fill="#040404"
      />
      <path
        d="M416.432 174.717C416.415 181.519 411.784 187.024 406.09 187.012C400.395 187 395.793 181.475 395.811 174.673C395.829 167.871 400.459 162.366 406.153 162.378C411.848 162.39 416.45 167.914 416.432 174.717Z"
        fill="#040404"
      />
      <path d="M498.238 103.817L489.472 64.5097" stroke="#2D61AE" strokeWidth="7" />
      <path d="M514.591 106.839L531.536 70.3046" stroke="#2D61AE" strokeWidth="7" />
      <path d="M524.19 119.343L558.879 98.8843" stroke="#2D61AE" strokeWidth="7" />
      <path
        d="M596.845 295.08C599.333 321.157 588.697 362.927 588.697 362.927L560.622 323.325C560.622 323.325 543.617 294.776 547.87 266.398C550.606 248.147 535.533 213.579 558.329 209.145C574.049 206.087 593.356 258.512 596.845 295.08Z"
        fill="#F0A093"
      />
      <path
        d="M636.5 435C636.5 435 629.468 388.997 613 353.5C590.389 304.76 577.812 286.976 543.589 248.316C543.589 248.316 474.77 174.241 444.435 199.945C434.214 213.494 466.782 243.047 485.211 258.09C469.082 246.295 440.789 228.685 429.202 240.482C422.281 251.738 441.713 268.92 457.924 280.611C442.765 271.977 422.932 263.853 414.648 274.286C400.394 292.237 442.147 326.847 468.022 356.316C505.5 399 484 483 484 483C484 483 496.98 488.5 537.5 485C605 479.17 636.5 435 636.5 435Z"
        fill="#F4B9AF"
      />
      <path
        d="M573.916 305.39C573.916 305.39 574.18 313.581 568.859 317.467C564.194 320.875 557.429 320.772 557.429 320.772M540.48 329.439C540.48 329.439 538.21 337.537 532.094 339.702C526.732 341.601 520.504 339.418 520.504 339.418M502.52 345.827C502.52 345.827 497.724 352.927 491.414 352.967C485.881 353.002 480.931 348.78 480.931 348.78"
        stroke="#F0A093"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M483.5 381C491.5 431 490.191 464.671 485 482C485 482 502.5 484.5 523 484C560.542 483.084 572.5 475.5 572.5 475.5C572.5 475.5 549.128 432.106 532.5 414.5C515.5 396.5 483.5 381 483.5 381Z"
        fill="#F0A093"
        stroke="#F0A093"
        strokeWidth="3"
      />
      <path
        d="M282.5 176.5C265.926 189.274 248 217.5 248 217.5L287.5 211C287.5 211 314.068 204.598 328 187C336.96 175.682 365.875 165 355 150.5C347.5 140.5 305.742 158.586 282.5 176.5Z"
        fill="#F0A093"
      />
      <path
        d="M193 292C193 292 212.204 236.902 237.5 214.5C269.442 186.212 298.419 182.225 341 179.5C341 179.5 424.5 176 427.5 206C425.678 218.751 389.351 217.433 369.766 215.779C386.112 217.967 413 223.471 413 236C410.56 245.759 389.146 244.729 372.813 242.441C386.755 245.822 403.158 251.962 402 262C400.007 279.271 348.973 260.217 323 278C305.629 289.893 289.5 320 289.5 320C289.5 320 256.949 315.374 237.5 309.5C220.06 304.233 193 292 193 292Z"
        fill="#F4B9AF"
      />
      <path
        d="M290.05 194.247C290.05 194.247 285.149 198.534 286.036 203.46C286.813 207.779 290.862 211.316 290.862 211.316M295.837 225C295.837 225 292.485 230.582 294.837 235C296.899 238.873 301.837 241 301.837 241M308.731 254.014C308.731 254.014 307.446 260.397 311.144 263.769C314.387 266.726 319.752 267.072 319.752 267.072"
        stroke="#F0A093"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M310.5 287C299.846 298.3 295.477 306.377 288.5 318.5C288.5 318.5 263.152 315.341 247.5 311C236.311 307.897 218.5 301 218.5 301C218.5 301 238.618 283.655 258.5 281.5C276.546 279.544 310.5 287 310.5 287Z"
        fill="#F0A093"
        stroke="#F0A093"
        strokeWidth="3"
      />
      <path d="M634.5 199.5L629 176" stroke="#F0A093" strokeWidth="36" strokeLinecap="round" />
      <circle cx="611.612" cy="146.568" r="43" fill="#F4B9AF" />
      <path
        d="M619 161C619 164.866 615.866 168 612 168C608.134 168 605 164.866 605 161C605 157.134 608.134 154 612 154C615.866 154 619 157.134 619 161Z"
        fill="#F0A093"
      />
      <path
        d="M586 158.5C586 162.366 582.866 165.5 579 165.5C575.134 165.5 572 162.366 572 158.5C572 154.634 575.134 151.5 579 151.5C582.866 151.5 586 154.634 586 158.5Z"
        fill="#F0A093"
      />
      <path
        d="M612.611 151.568C612.611 153.778 610.821 155.568 608.611 155.568C606.402 155.568 604.611 153.778 604.611 151.568C604.611 149.359 606.402 147.568 608.611 147.568C610.821 147.568 612.611 149.359 612.611 151.568Z"
        fill="#373131"
      />
      <path
        d="M585.611 150.568C585.611 152.778 583.821 154.568 581.611 154.568C579.402 154.568 577.611 152.778 577.611 150.568C577.611 148.359 579.402 146.568 581.611 146.568C583.821 146.568 585.611 148.359 585.611 150.568Z"
        fill="#373131"
      />
      <path
        d="M597.111 140.068C570.612 137.068 562.111 116.068 569.612 112.568C574.854 111.762 572.315 112.359 577.612 112.068C590.779 111.345 595.612 101.068 610.611 102.068C636.112 103.768 650.959 114.21 654 135.5C655 142.5 660.612 167.568 644.612 163.068C635.062 160.383 646.5 153.068 646.5 143.5C646.5 141.073 642.889 134.932 636.5 138.5C630.111 142.068 636.943 152.874 630.611 153.068C624.174 153.267 630.111 140.069 623.611 137.068C617.111 134.068 609.459 141.466 597.111 140.068Z"
        fill="#373131"
      />
      <defs>
        <linearGradient
          id="paint0_linear_713_4489"
          x1="485.5"
          y1="24"
          x2="485.5"
          y2="504.553"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEEBFE" />
          <stop offset="1" stopColor="#DEEBFE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_713_4489"
          x1="792.492"
          y1="166"
          x2="792.492"
          y2="653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1E4FF" />
          <stop offset="1" stopColor="#5293F0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_713_4489"
          x1="792.492"
          y1="166"
          x2="792.492"
          y2="653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1E4FF" />
          <stop offset="1" stopColor="#5293F0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_713_4489"
          x1="792.492"
          y1="166"
          x2="792.492"
          y2="653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1E4FF" />
          <stop offset="1" stopColor="#5293F0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_713_4489"
          x1="792.492"
          y1="166"
          x2="792.492"
          y2="653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1E4FF" />
          <stop offset="1" stopColor="#5293F0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_713_4489"
          x1="792.492"
          y1="166"
          x2="792.492"
          y2="653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1E4FF" />
          <stop offset="1" stopColor="#5293F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NotFoundSvg;



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/NotFoundSvg.jsx